
/* injects from baggage-loader */
var Template = require('./template.js');

import { Component } from "react";
import PropTypes from "prop-types";
import { MarketContext } from '../gameListAsian/marketContext';
import { connect } from "react-redux";
import { toggleGameEventsInList } from "../../../actions/ui";
import { withRouter } from "react-router";
import { GameTypeViewEnum } from "../../../constants/enums/gameType";

class MatchOfTheDayGame extends Component {
    openGame () {
        const { game } = this.props
        this.props.dispatch(toggleGameEventsInList(true, game.id))
        this.props.router.push(`/${GameTypeViewEnum[game.type]}/${game.sportAlias}/${game.region.id}/${game.competition.id}`)
    }
    render () {
        return Template.default.apply(this); //eslint-disable-line no-undef
    }
}

MatchOfTheDayGame.contextType = MarketContext;

MatchOfTheDayGame.propTypes = {
    game: PropTypes.object
};

export default connect()(withRouter(MatchOfTheDayGame));